import { NGSWorkfileRequest } from './ngs-workfile-request';
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { BBResponseContainer } from "../carrier/response-container";
import { LiquidLevelDetectionRequest } from "./liquid-level-detection-request";
import { LiquidConcentrationDetectionRequest } from "./liquid-concentration-detection-request";
import { NGSUpdateSampleRequestResponse } from './model/NGSUpdateSampleRequestResponse';
import { timeout, tap } from 'rxjs/operators';

@Injectable()
export class NgsVolumeAdjustmentService {


  constructor(private http: HttpClient) {
  }

  liquidLevelDetection(liquidLevelDetectionRequest: LiquidLevelDetectionRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_ENTRY_QC_URL + 'sample/measurement/volume/upload';
        // tslint:disable-next-line:max-line-length
    return this.http.post<BBResponseContainer>(url, liquidLevelDetectionRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  liquidConcentrationDetection(liquidConcentrationDetectionRequest: LiquidConcentrationDetectionRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_ENTRY_QC_URL + 'sample/measurement/concentration/upload';
        // tslint:disable-next-line:max-line-length
    return this.http.post<BBResponseContainer>(url, liquidConcentrationDetectionRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }

  getMachineList(): Observable<BBResponseContainer> {

    let url = environment.BB_MDMSERVICE_URL + 'admin/mdm/machine';
    let requestParam = new HttpParams();
    const options = url ? { params: requestParam } : {};

    return this.http.get<BBResponseContainer>(url, options).pipe(timeout(environment.defaultTimeout));
  }

  getWorkfiles(ngsWorkfileRequest: NGSWorkfileRequest): Observable<BBResponseContainer> {
    let url = environment.BB_NGS_ENTRY_QC_URL + 'entryqc/flxplate';
    return this.http.post<BBResponseContainer>(url, ngsWorkfileRequest).pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
      error.url = url;
    }));
  }


  /**
  * REST call to update sample's target volume
  */
  updateSampleTargetVolume(ngsUpdateSampleRequest: NGSUpdateSampleRequestResponse): Observable<BBResponseContainer> {
    const url = environment.BB_NGS_ENTRY_QC_URL + 'sample/measurement/targetvolume';
    return this.http.post<BBResponseContainer>(url, ngsUpdateSampleRequest)
      .pipe(timeout(environment.defaultTimeout),tap(event => { }, error => {
        error.url = url;
      }));
  }

}
